import React, { Component } from 'react';
import { Col, Container, Row } from 'reactstrap';
import { connect } from 'react-redux';
import EditorCard from './Editor/EditorCard';
import Sidebar from './Sidebar/Sidebar';
import TitleCard from './Title/TitleCard';
import withErrorNotification from '../../hof/withErrorNotification';
import { Drafts } from '../../services/Drafts';
import Notifications from '../../hof/notifications';
import { addDraft, updateDraft } from '../../redux/actions/draftsActions';
import { updatePost, addPost } from '../../redux/actions/postsActions';
import validateArticleForm from './validator/validateArticleForm';
import { reduxForm, isDirty} from 'redux-form';
import { initialize } from 'redux-form';
import { Posts } from '../../services/Posts';
import { Prompt } from 'react-router'
import {withTranslation} from "react-i18next";
import { categoryAdd } from '../../redux/actions/blogsActions';

class WritePage extends Component {

  constructor() {
    super();
    this.state = {
      draftId: null,
      inProgress: false,
      status: null,
      parent_category: null,
      permlink: null
    }
  }

  componentDidMount = async () => {

    setTimeout(async () => {
      try {
        const { match, dispatch } = this.props;
        const { params: { draftId } } = match;

        if( draftId ) {
          this.setState({ draftId })
          const blogId = this.props.blogs.blog._id;
          let draft = null;
          try {
            draft = await Drafts.getSingle(blogId, draftId);
          } catch (error) {
            console.log(error);
          }

          if(!draft) {
            draft = await Posts.getSingle(blogId, draftId);
          }

          console.log(draft);

          if(draft.status) {
            this.setState({
              status: draft.status,
              parent_category: draft.parent_category,
              permlink: draft.permlink
            });
          }

          dispatch(initialize('article', prepareSafeArticle(draft, this.props.blogs.blog.categories)));
        }

      } catch (error) {
        console.log(error);
      }
    }, 300);
  }

  handlePublish = async (values) => {

    validateArticleForm(values);

    this.setState({inProgress: true});

    const blogId = localStorage.getItem('blog');
    const categoriesIds = values.categories && values.categories.map(cat => cat.value)
    const { draftId, status } = this.state;

    const post = {
      ...values,
      categories: categoriesIds
    }

    // TODO distinguish draftId and postId
    if(draftId && status !== 'published') {
      post.draftId = draftId;
    }

    console.log(post);

    await withErrorNotification( async () => {

      let response = null;

      if(this.state.status !== 'published') {
        response = await Posts.publish(post, blogId);
        console.log(response.result);
        Notifications.showNotification("Success", "Post published successfully", "success");
        this.props.onPublishPost(response.result);
        this.setState({status: response.result.status, parent_category: response.result.parent_category, draftId: response.result._id, permlink: response.result.permlink});
      } else if(this.state.status === 'published') {
        response = await Posts.update(blogId, this.state.draftId, post);
        Notifications.showNotification("Success", "Post updated successfully", "success");
        this.props.onUpdatePost(response.post );
        this.setState({status: response.post.status, parent_category: response.post.parent_category, draftId: response.post._id, permlink: response.post.permlink});
      }


      this.props.setDraftFormInititState(post, this.props.blogs.blog.categories);

      this.setState({inProgress: false});
    }, () => {
      this.setState({inProgress: false});
    });

  }

  handleSaveDraft = async (values) => {

    validateArticleForm(values);

    const blogId = localStorage.getItem('blog');
    const parsedCategories = values.categories && values.categories.map(cat => cat.value)

    const draft = {
      ...values,
      categories: parsedCategories
    }

    const { draftId } = this.state;

    if (draftId) {
      await this.handleUpdateDraft(blogId, draftId, draft);
    } else {
      await this.handleCreateDraft(blogId, draft);
    }

    this.props.setDraftFormInititState(draft, this.props.blogs.blog.categories);

  }

  handleUpdateDraft = async (blogId, draftId, draft) => {
    await withErrorNotification(async () => {
      const createdDraft = await Drafts.updateDraft(blogId, draftId, draft);
      Notifications.showNotification('Success', 'Draft updated successfully', 'success');
      this.props.onUpdateDraft(createdDraft);
      this.props.onUpdateDraft(createdDraft);
    })
  }

  handleCreateDraft = async (blogId, draft) => {
    await withErrorNotification(async () => {
      const createdDraft = await Drafts.createDraft(blogId, draft);
      Notifications.showNotification('Success', 'Draft saved successfully', 'success');
      this.props.onCreateDraft(createdDraft);
      console.log(createdDraft);
      this.setState({ draftId: createdDraft._id });
    })
  }

  render() {

    const { handleSubmit, t } = this.props;

    return (

      <Container className="dashboard">
        <Prompt when={this.props.isDirty} message={t('write.you_have_unsaved_changes')} />
        <Row>
          <Col md={12} lg={12}>
            <h3 className="page-title">{t('write.title')}</h3>
          </Col>
          <Col md={12} lg={9}>
            <Row>
              <TitleCard
                title={`${t('write.editing_at')}: ${this.props.blogs.blog.title}`}
                slogan={this.props.blogs.blog.slogan}
                domain={this.props.blogs.blog.domain}
                status={this.state.status}
              />
              <EditorCard />
            </Row>
          </Col>
          <Col md={12} lg={3}>
            <Sidebar
              draftId={this.state.draftId}
              handleSaveDraft={handleSubmit(this.handleSaveDraft)}
              handlePublish={handleSubmit(this.handlePublish)}
              inProgress={this.state.inProgress}
              categories={this.props.blogs.blog.categories}
              error={this.props.error}
              status={this.state.status}
              parent_category={this.state.parent_category}
              domain={this.props.blogs.blog.domain}
              permlink={this.state.permlink}
              blog={this.props.blogs.blog}
              onCategoryAdd={this.props.onCategoryAdd}
            />
          </Col>
        </Row>
      </Container>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    blogs: state.blogs,
    isDirty: isDirty('article')(state),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onCategoryAdd: (category) => { dispatch(categoryAdd(category)) },
    onCreateDraft: (draft) => (dispatch(addDraft(draft))),
    onPublishPost: (post) => (dispatch(addPost(post))),
    onUpdateDraft: (draft) => (dispatch(updateDraft(draft))),
    onUpdatePost: (post) => (dispatch(updatePost(post))),
    setDraftFormInititState: (draft, blogCategories) => ( dispatch(initialize('article', prepareSafeArticle(draft, blogCategories))))
  }
}

const prepareSafeArticle = (draft, blogCategories) => {

  const { title, body, categories, tags, decline_reward, permlink, featured_image, parent_category } = draft;

  let parsedCategories = [];

  for (let blogCategory of blogCategories) {
    for (let category of categories) {
      if (category === blogCategory._id) {
        parsedCategories.push({ value: blogCategory._id, label: blogCategory.name })
      }
    }
  }

  return {
    title,
    body,
    tags,
    decline_reward,
    permlink,
    featured_image,
    categories: parsedCategories,
    parent_category
  }
}

WritePage = connect(mapStateToProps, mapDispatchToProps)(WritePage);
WritePage = reduxForm({
  form: 'article', // a unique identifier for this form
  destroyOnUnmount: true,
  initialValues: {
    tags: process.env.DEFAULT_TAG ? [process.env.DEFAULT_TAG] : ['engrave'],
    decline_reward: false
  }
})(WritePage)

// we need to pass WritePage to Route and because of reduxForm, it's an object and need to be a function
class WritePageWrapper extends Component {
  render() {
    return <WritePage { ...this.props } />
  }
}

export default withTranslation('dashboard')(WritePageWrapper);
